export enum EIntegrationUrls {
  CSV = 'csv',
  INTEGRATION = 'integration',
  PREVIEW = 'preview',
  EXECUTE = 'execute',
  TEMPLATE = 'template',
}
